module.exports = __webpack_public_path__ + "static/media/mercadoPago.c43732ae.png";